// extracted by mini-css-extract-plugin
export var notificationHost = "_kx-0";